export default __webpack_public_path__ + "static/media/photo--sm--15.b033bb7c.jpg";